(() => {
  const siteHeader = document.querySelector('[data-site-header]');
  if (!siteHeader) return;

  const headerInner = siteHeader.querySelector('.site-header__inner');
  const syncHeaderOffsets = () => {
    const fullHeight = Math.ceil(siteHeader.getBoundingClientRect().height);
    const compactHeight = Math.ceil((headerInner || siteHeader).getBoundingClientRect().height);
    document.documentElement.style.setProperty('--site-header-offset', fullHeight + 'px');
    document.documentElement.style.setProperty('--sticky-header-offset', compactHeight + 'px');
  };
  const updateHeaderState = () => {
    siteHeader.classList.toggle('is-scrolled', window.scrollY > 6);
    window.requestAnimationFrame(syncHeaderOffsets);
  };

  syncHeaderOffsets();
  updateHeaderState();
  if ('ResizeObserver' in window) {
    const observer = new ResizeObserver(syncHeaderOffsets);
    observer.observe(siteHeader);
    if (headerInner) observer.observe(headerInner);
  }
  window.addEventListener('scroll', updateHeaderState, { passive: true });
  window.addEventListener('resize', syncHeaderOffsets);
})();

/* Final PDP active-section override. */
(() => {
  const nav = document.querySelector('[data-pdp-anchor-nav]');
  if (!nav) return;
  const links = Array.from(nav.querySelectorAll('[data-pdp-anchor-link]'));
  const sections = links
    .map((link) => document.getElementById(link.dataset.pdpAnchorLink))
    .filter(Boolean)
    .sort((a, b) => a.offsetTop - b.offsetTop);
  const setActive = (sectionId = '') => {
    document.querySelectorAll('[data-pdp-anchor-link]').forEach((link) => {
      const active = Boolean(sectionId) && link.dataset.pdpAnchorLink === sectionId;
      link.classList.toggle('is-active', active);
      if (active) link.setAttribute('aria-current', 'true');
      else link.removeAttribute('aria-current');
    });
    document.querySelectorAll('[data-thumb-section-link]').forEach((link) => {
      link.classList.toggle('is-active', Boolean(sectionId) && link.dataset.thumbSectionLink === sectionId);
    });
  };
  const markerOffset = () => {
    const cssSticky = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--sticky-header-offset'));
    const header = document.querySelector('[data-site-header] .site-header__inner') || document.querySelector('[data-site-header]');
    const headerHeight = header?.getBoundingClientRect().height || 0;
    return (Number.isFinite(cssSticky) ? cssSticky : headerHeight) + (nav.getBoundingClientRect().height || 0) + 10;
  };
  const isSticky = () => {
    const cssTop = parseFloat(getComputedStyle(nav).top);
    const stickyTop = Number.isFinite(cssTop) ? cssTop : 0;
    return nav.getBoundingClientRect().top <= stickyTop + 2;
  };
  const update = () => {
    if (!sections.length || !isSticky()) {
      setActive('');
      return;
    }
    const marker = markerOffset();
    let current = '';
    for (const section of sections) {
      const rect = section.getBoundingClientRect();
      if (rect.top <= marker && rect.bottom > marker) {
        current = section.id;
        break;
      }
    }
    if (!current) {
      sections.forEach((section) => {
        if (section.getBoundingClientRect().top <= marker) current = section.id;
      });
    }
    setActive(current);
  };
  requestAnimationFrame(update);
  window.addEventListener('scroll', update, { passive: true });
  window.addEventListener('resize', update);
  window.addEventListener('hashchange', update);
})();

/* Stale storefront HTML guard: normalize old cached mobile nav and rail CSS. */
(() => {
  const styleId = 'dominator-live-rail-guard';
  if (!document.getElementById(styleId)) {
    const style = document.createElement('style');
    style.id = styleId;
    style.textContent = `

      /* 2026-06-16 runtime menu cleanup */
      .site-header,
      .site-header:not(.is-scrolled),
      .site-header.is-scrolled {
        background: #050506 !important;
        background-color: #050506 !important;
        color: #fff !important;
        backdrop-filter: none !important;
      }
      .site-header .brand,
      .site-header .brand-logo,
      .site-header .site-nav a,
      .site-header .site-nav button,
      .site-header .cart-link,
      .site-header .menu-button {
        color: #fff !important;
      }
      .template-product .site-header.is-scrolled .site-header__inner {
        min-height: 44px !important;
      }
      .template-product .pdp-anchor-nav {
        top: var(--sticky-header-offset, 44px) !important;
        height: 22px !important;
        min-height: 22px !important;
        max-height: 22px !important;
        padding-top: 0 !important;
        padding-bottom: 0 !important;
        border-top: 0 !important;
        border-bottom: 1px solid rgba(255,255,255,.14) !important;
        background: #050506 !important;
        box-shadow: none !important;
        overflow: hidden !important;
      }
      .template-product .pdp-anchor-nav a {
        height: 20px !important;
        min-height: 20px !important;
        max-height: 20px !important;
        background: #fff !important;
        color: #0d1424 !important;
        border-color: rgba(13,20,36,.16) !important;
        border-radius: 4px !important;
        font-size: 9px !important;
        font-weight: 800 !important;
        line-height: 1 !important;
      }
      .template-product .pdp-anchor-nav a.is-active,
      .template-product .pdp-anchor-nav a[aria-current="true"] {
        background: #006cff !important;
        border-color: #006cff !important;
        color: #fff !important;
      }

      /* 2026-06-16 runtime scrolled product header control clamp */
      .template-product .site-header.is-scrolled .brand-logo { width: 166px !important; }
      .template-product .site-header.is-scrolled .site-header__actions .button,
      .template-product .site-header.is-scrolled .cart-link {
        min-height: 38px !important;
        height: 38px !important;
        padding-top: 0 !important;
        padding-bottom: 0 !important;
      }
      .template-product .site-header.is-scrolled .cart-link {
        min-width: 38px !important;
        padding-left: 10px !important;
        padding-right: 10px !important;
      }

      /* 2026-06-16 runtime top-state header parity restore */
      .site-header:not(.is-scrolled) {
        background: #050506 !important;
        background-color: #050506 !important;
        backdrop-filter: none !important;
      }
      .site-header.is-scrolled {
        background: #050506 !important;
        background-color: #050506 !important;
        backdrop-filter: none !important;
      }
      @media (max-width: 720px) {
        .menu-button { display: none !important; }
        .pdp-anchor-nav {
          box-sizing: border-box !important;
          height: 23px !important;
          min-height: 23px !important;
          max-height: 23px !important;
          padding-top: 0 !important;
          padding-bottom: 0 !important;
          border-top: 0 !important;
          border-bottom-width: 0 !important;
        }
        .pdp-anchor-nav a {
          box-sizing: border-box !important;
          height: 20px !important;
          min-height: 20px !important;
          max-height: 20px !important;
          padding-top: 0 !important;
          padding-bottom: 0 !important;
        }
      }

      /* 2026-06-16 final runtime sticky/navigation cleanup */
      :root {
        --dominator-compact-header-height: 44px;
        --dominator-mobile-compact-header-height: 46px;
      }
      .site-header,
      .site-header:not(.is-scrolled),
      .site-header.is-scrolled {
        background: #050506 !important;
        background-color: #050506 !important;
        color: #fff !important;
        backdrop-filter: none !important;
      }
      .template-product .site-header.is-scrolled .site-header__inner {
        min-height: var(--dominator-compact-header-height) !important;
        height: var(--dominator-compact-header-height) !important;
        padding-top: 0 !important;
        padding-bottom: 0 !important;
      }
      .template-product .site-header.is-scrolled .brand-logo { width: 158px !important; }
      .template-product .site-header.is-scrolled .site-header__actions .button,
      .template-product .site-header.is-scrolled .cart-link {
        min-height: 34px !important;
        height: 34px !important;
      }
      .template-product .pdp-anchor-nav {
        top: var(--dominator-compact-header-height) !important;
        height: 20px !important;
        min-height: 20px !important;
        max-height: 20px !important;
        padding: 0 max(10px, calc((100vw - 1240px) / 2 + 10px)) !important;
        border-top: 0 !important;
        border-bottom: 1px solid rgba(255,255,255,.12) !important;
        background: #050506 !important;
        box-shadow: none !important;
        overflow: hidden !important;
      }
      .template-product .pdp-anchor-nav a {
        height: 18px !important;
        min-height: 18px !important;
        max-height: 18px !important;
        padding: 0 8px !important;
        background: #fff !important;
        color: #0d1424 !important;
        border-color: rgba(13,20,36,.16) !important;
        border-radius: 4px !important;
        font-size: 8px !important;
        font-weight: 800 !important;
        line-height: 1 !important;
        letter-spacing: 0 !important;
        white-space: nowrap !important;
      }
      .template-product .pdp-anchor-nav a.is-active,
      .template-product .pdp-anchor-nav a[aria-current="true"] {
        background: #006cff !important;
        border-color: #006cff !important;
        color: #fff !important;
        box-shadow: none !important;
      }
      @media (max-width: 720px) {
        .site-header .menu-button,
        .template-product .menu-button { display: none !important; }
        .template-product .site-header.is-scrolled .site-header__inner {
          min-height: var(--dominator-mobile-compact-header-height) !important;
          height: var(--dominator-mobile-compact-header-height) !important;
          grid-template-columns: minmax(0, 1fr) auto !important;
          padding-left: 18px !important;
          padding-right: 18px !important;
        }
        .template-product .pdp-anchor-nav {
          top: var(--dominator-mobile-compact-header-height) !important;
          box-sizing: border-box !important;
          height: 21px !important;
          min-height: 21px !important;
          max-height: 21px !important;
          grid-auto-columns: minmax(82px, 1fr) !important;
          gap: 4px !important;
          padding: 0 8px !important;
          overflow-x: auto !important;
          overflow-y: hidden !important;
          scrollbar-width: none !important;
        }
        .template-product .pdp-anchor-nav::-webkit-scrollbar { display: none !important; }
        .template-product .pdp-anchor-nav a {
          box-sizing: border-box !important;
          height: 18px !important;
          min-height: 18px !important;
          max-height: 18px !important;
          padding: 0 6px !important;
          font-size: 8px !important;
        }
        body.template-product .thumb-nav {
          display: block !important;
          visibility: visible !important;
          opacity: 1 !important;
          pointer-events: auto !important;
          position: fixed !important;
          right: 12px !important;
          bottom: calc(14px + env(safe-area-inset-bottom)) !important;
          width: 64px !important;
          height: 64px !important;
          min-height: 64px !important;
          z-index: 72 !important;
        }
        body.template-product .thumb-nav--pdp { bottom: calc(14px + env(safe-area-inset-bottom)) !important; }
        body.template-product.has-sticky-cart-visible .thumb-nav--pdp { bottom: calc(92px + env(safe-area-inset-bottom)) !important; }
        body.template-product .thumb-nav__main {
          width: 64px !important;
          height: 64px !important;
          min-height: 64px !important;
          border: 2px solid rgba(255,255,255,.94) !important;
          background: #0d1424 !important;
          color: #fff !important;
        }
        .template-product .pdp-media__mobile-install-video { display: block !important; }
        .template-product .pdp-media__thumbs .pdp-media__install-video-thumb,
        .template-product .pdp-media__thumbs button[data-media-label="Install video"] { display: grid !important; }
        .template-product .pdp-media__thumbs button[data-media-label="Adjustment GIF"] { display: grid !important; }
      }


      /* PDP media strip parity: React shows the install video thumb as a first-row control. */
      .template-product .pdp-media__mobile-install-video { display: block !important; }
      .template-product .pdp-media__thumbs .pdp-media__install-video-thumb,
      .template-product .pdp-media__thumbs button[data-media-label="Install video"] { display: grid !important; }

      /* 2026-06-16 runtime mobile header action parity */
      .site-header:not(.is-scrolled) {
        background: #050506 !important;
        background-color: #050506 !important;
        backdrop-filter: none !important;
      }
      .site-header.is-scrolled {
        background: #050506 !important;
        background-color: #050506 !important;
        backdrop-filter: none !important;
      }
      @media (max-width: 720px) {
        .site-header__inner {
          grid-template-columns: 222px 100px !important;
          min-height: 78px !important;
          padding-left: 24px !important;
          padding-right: 24px !important;
          gap: 20px !important;
        }
        .site-header__actions {
          display: flex !important;
          width: 100px !important;
          min-width: 100px !important;
          justify-self: end !important;
          align-items: center !important;
          justify-content: flex-end !important;
          gap: 6px !important;
        }
        .site-header__actions .button.button--dark {
          display: inline-flex !important;
          width: 50px !important;
          min-width: 50px !important;
          height: 44px !important;
          min-height: 44px !important;
          padding: 0 !important;
          align-items: center !important;
          justify-content: center !important;
          border: 0 !important;
          border-radius: 8px !important;
          background: #fff !important;
          color: #0d1424 !important;
          font-size: 13px !important;
          font-weight: 900 !important;
          line-height: 1 !important;
          text-transform: none !important;
          white-space: nowrap !important;
        }
        .site-header__actions .cart-link {
          display: inline-flex !important;
          width: 44px !important;
          min-width: 44px !important;
          height: 44px !important;
          min-height: 44px !important;
          padding: 0 !important;
          align-items: center !important;
          justify-content: center !important;
          border-color: rgba(255, 255, 255, 0.18) !important;
          border-radius: 8px !important;
          background: rgba(255, 255, 255, 0.08) !important;
          color: #fff !important;
        }
        .site-header__actions .cart-link svg { width: 20px !important; height: 20px !important; }
        .site-header__actions .menu-button,
        .site-header .menu-button,
        .template-product .menu-button { display: none !important; }
        .template-product .site-header.is-scrolled .site-header__inner {
          grid-template-columns: 222px 100px !important;
          min-height: var(--dominator-mobile-compact-header-height) !important;
          height: var(--dominator-mobile-compact-header-height) !important;
          padding-left: 24px !important;
          padding-right: 24px !important;
        }
        .template-product .site-header.is-scrolled .site-header__actions .button.button--dark,
        .template-product .site-header.is-scrolled .site-header__actions .cart-link {
          height: 38px !important;
          min-height: 38px !important;
        }
      }
    `;
    document.head.appendChild(style);
  }

  const nav = document.querySelector('[data-thumb-nav]');
  if (!nav) return;

  const isPdp = nav.classList.contains('thumb-nav--pdp') || document.body.classList.contains('template-product');
  const expectedItems = isPdp
    ? ['Home', 'Products', 'Explore', 'Reviews', 'Q&A', 'Resources']
    : ['Home', 'Products', 'Resources', 'Support'];
  const currentItems = Array.from(nav.querySelectorAll('.thumb-nav__item')).map((item) => item.textContent.trim());
  const hasCurrentIcon = Boolean(nav.querySelector('.thumb-nav__icon--nav'));
  const needsMarkupRefresh = !hasCurrentIcon || currentItems.join('|') !== expectedItems.join('|');

  if (!needsMarkupRefresh) return;

  nav.classList.toggle('thumb-nav--pdp', isPdp);
  nav.innerHTML = `
    <button class="thumb-nav__main" type="button" data-thumb-toggle aria-expanded="false" aria-label="Open quick navigation">
      <svg class="thumb-nav__icon thumb-nav__icon--nav" viewBox="0 0 24 24" aria-hidden="true" focusable="false"><circle cx="12" cy="12" r="8.5"></circle><path d="m15.5 8.5-2 5-5 2 2-5 5-2Z"></path></svg>
      <svg class="thumb-nav__icon thumb-nav__icon--open" viewBox="0 0 24 24" aria-hidden="true" focusable="false"><circle cx="12" cy="12" r="9"></circle><path d="M9.5 9a2.8 2.8 0 0 1 5.2 1.4c0 2.2-2.7 2.4-2.7 4.2"></path><path d="M12 18h.01"></path></svg>
      <span data-thumb-toggle-label>Nav</span>
    </button>
    <a class="thumb-nav__item thumb-nav__item--1" href="/">Home</a>
    <button class="thumb-nav__item thumb-nav__item--2" type="button" data-thumb-group="products">Products</button>
    ${isPdp ? `
      <button class="thumb-nav__item thumb-nav__item--3" type="button" data-thumb-group="explore">Explore</button>
      <a class="thumb-nav__item thumb-nav__item--4" href="#reviews" data-thumb-section-link="reviews">Reviews</a>
      <a class="thumb-nav__item thumb-nav__item--5" href="#questions" data-thumb-section-link="questions">Q&amp;A</a>
      <button class="thumb-nav__item thumb-nav__item--6" type="button" data-thumb-group="resources">Resources</button>
    ` : `
      <button class="thumb-nav__item thumb-nav__item--3" type="button" data-thumb-group="resources">Resources</button>
      <button class="thumb-nav__item thumb-nav__item--4" type="button" data-support-open data-support-intent="support">Support</button>
    `}
    <div class="thumb-nav__children" data-thumb-children="products" hidden>
      <a class="thumb-nav__child thumb-nav__child--0" href="/collections/all">All</a>
      <a class="thumb-nav__child thumb-nav__child--1" href="/collections/hoops">Hoops</a>
      <a class="thumb-nav__child thumb-nav__child--2" href="/collections/pickleball">Nets</a>
      <a class="thumb-nav__child thumb-nav__child--3" href="/collections/lights">Lights</a>
    </div>
    ${isPdp ? `
      <div class="thumb-nav__children" data-thumb-children="explore" hidden>
        <a class="thumb-nav__child thumb-nav__child--0" href="#product-compare" data-thumb-section-link="product-compare">Compare</a>
        <a class="thumb-nav__child thumb-nav__child--1" href="#inspect" data-thumb-section-link="inspect">360/AR</a>
        <a class="thumb-nav__child thumb-nav__child--2" href="#social-proof" data-thumb-section-link="social-proof">Gallery</a>
      </div>
    ` : ''}
    <div class="thumb-nav__children" data-thumb-children="resources" hidden>
      <a class="thumb-nav__child thumb-nav__child--0" href="/pages/court-planner">Planner</a>
      <a class="thumb-nav__child thumb-nav__child--1" href="/pages/resources#installation-manuals">Manuals</a>
      <button class="thumb-nav__child thumb-nav__child--2" type="button" data-support-open data-support-intent="parts" data-support-query="I need help finding parts, accessories, or manuals.">Parts</button>
      <button class="thumb-nav__child thumb-nav__child--3" type="button" data-support-open data-support-intent="support">Support</button>
    </div>
  `;

  const groups = isPdp ? ['products', 'explore', 'resources'] : ['products', 'resources'];
  const toggle = nav.querySelector('[data-thumb-toggle]');
  const label = nav.querySelector('[data-thumb-toggle-label]');
  const setGroup = (group = '') => {
    groups.forEach((candidate) => nav.classList.toggle(`thumb-nav--${candidate}-open`, candidate === group));
    nav.querySelectorAll('[data-thumb-group]').forEach((button) => button.classList.toggle('selected', button.dataset.thumbGroup === group));
    nav.querySelectorAll('[data-thumb-children]').forEach((children) => {
      children.hidden = children.dataset.thumbChildren !== group;
    });
  };
  const setOpen = (open) => {
    nav.classList.toggle('is-open', open);
    toggle?.setAttribute('aria-expanded', String(open));
    if (label) label.textContent = open ? 'Close' : 'Nav';
    if (!open) setGroup('');
  };
  toggle?.addEventListener('click', () => setOpen(!nav.classList.contains('is-open')));
  nav.querySelectorAll('[data-thumb-group]').forEach((button) => {
    button.addEventListener('click', () => {
      const group = button.dataset.thumbGroup || '';
      const alreadyOpen = nav.classList.contains(`thumb-nav--${group}-open`);
      setOpen(true);
      setGroup(alreadyOpen ? '' : group);
    });
  });
  nav.querySelectorAll('a').forEach((link) => link.addEventListener('click', () => setOpen(false)));
  nav.querySelectorAll('[data-support-open]').forEach((button) => {
    button.addEventListener('click', () => {
      setOpen(false);
      window.DominatorTheme?.openSupport?.(button.dataset.supportIntent || 'support', button.dataset.supportQuery || '');
    });
  });
  setGroup('');
})();


/* 2026-06-16 rendered QA defect pass: selected-finish media, sticky cart, overlay state. */
(() => {
  const $ = (selector, root = document) => root.querySelector(selector);
  const $$ = (selector, root = document) => Array.from(root.querySelectorAll(selector));
  const variantData = (() => {
    try {
      return JSON.parse($('[data-product-variant-data]')?.textContent || '{}').variants || [];
    } catch (error) {
      return [];
    }
  })();
  const selectedOptions = () => $$('[data-option-select]').map((select) => select.value);
  const selectedVariant = () => {
    const options = selectedOptions();
    return variantData.find((variant) => options.every((value, index) => variant.options?.[index] === value)) || variantData[0] || null;
  };
  const productTitle = () => $('h1')?.textContent?.trim() || $('[data-product-root]')?.dataset.productHandle || 'Dominator product';
  const isMeaningfulFinish = (value = '') => {
    const normalized = String(value || '').trim();
    return normalized && !/^default(?:\s+title)?$/i.test(normalized);
  };
  const setImage = (image, src, alt) => {
    if (!image) return;
    if (src) {
      image.setAttribute('src', src);
      image.removeAttribute('srcset');
      image.removeAttribute('sizes');
    }
    image.setAttribute('alt', alt);
  };
  const syncSelectedFinishSurfaces = () => {
    const variant = selectedVariant();
    if (!variant) return;
    const rawFinish = variant.options?.[0] || variant.title || '';
    const finish = isMeaningfulFinish(rawFinish) ? String(rawFinish).trim() : '';
    const title = productTitle();
    const alt = finish ? title + ' ' + finish : title + ' product image';
    const imageSrc = variant.featuredImage || '';

    $$('[data-product-finish-label]').forEach((node) => {
      node.textContent = document.body.classList.contains('template-product') && finish ? 'Finish shown: ' + finish : 'Product shown';
    });
    $$('[data-product-price-note]').forEach((node) => {
      node.textContent = finish ? finish + ' finish price. Other finishes may vary.' : '';
      node.hidden = !finish;
    });
    $$('[data-product-preview-image]').forEach((image) => setImage(image, imageSrc, alt));
    $$('[data-product-media-main] img').forEach((image) => setImage(image, imageSrc, alt));
    $$('[data-product-media-main] [data-media-caption-label]').forEach((node) => {
      node.textContent = finish ? 'Selected finish' : 'Product shown';
    });
    $$('[data-product-media-main] [data-media-caption-title]').forEach((node) => {
      node.textContent = finish || title;
    });
  };

  if (variantData.length) {
    $$('[data-option-select]').forEach((select) => select.addEventListener('change', () => requestAnimationFrame(syncSelectedFinishSurfaces)));
    $$('[data-variant-pill]').forEach((button) => button.addEventListener('click', () => setTimeout(syncSelectedFinishSurfaces, 0)));
    // Initial PDP media stays on the hero/court view; variant media sync runs after selection.
  }

  const sticky = $('[data-sticky-add-to-cart]');
  const productForm = $('[data-product-form]');
  const mainButton = $('[data-product-add-submit]', productForm || document);
  const stickyButton = $('[data-sticky-add-button]', sticky || document);
  const updateStickyVisibility = () => {
    if (!sticky || !mainButton) return;
    const rect = mainButton.getBoundingClientRect();
    const passedMainControls = rect.bottom < 80;
    const shouldShow = window.scrollY > 320 && passedMainControls && !mainButton.disabled;
    sticky.classList.toggle('is-visible', shouldShow);
    document.body.classList.toggle('has-sticky-cart-visible', shouldShow);
  };
  const mirrorStickyButtonState = () => {
    if (!mainButton || !stickyButton) return;
    const label = mainButton.textContent.trim();
    const transient = label === 'Adding' || label === 'Added';
    stickyButton.disabled = transient || mainButton.disabled;
    if (transient) stickyButton.textContent = label;
    else if (stickyButton.textContent.trim() === 'Adding' || stickyButton.textContent.trim() === 'Added') stickyButton.textContent = 'Add to cart';
    updateStickyVisibility();
  };
  if (sticky && mainButton) {
    updateStickyVisibility();
    window.addEventListener('scroll', updateStickyVisibility, { passive: true });
    window.addEventListener('resize', updateStickyVisibility);
    new MutationObserver(mirrorStickyButtonState).observe(mainButton, { attributes: true, childList: true, characterData: true, subtree: true });
    mainButton.addEventListener('click', () => setTimeout(mirrorStickyButtonState, 0));
    mirrorStickyButtonState();
  }

  const supportDrawer = $('[data-support-drawer]');
  const syncOverlayState = () => {
    const supportOpen = Boolean(supportDrawer && !supportDrawer.hidden);
    document.body.classList.toggle('support-open', supportOpen);
    if (supportOpen) $('[data-thumb-nav]')?.classList.remove('is-open');
  };
  if (supportDrawer) {
    syncOverlayState();
    new MutationObserver(syncOverlayState).observe(supportDrawer, { attributes: true, attributeFilter: ['hidden'] });
    document.addEventListener('click', (event) => {
      if (event.target.closest('[data-support-open], [data-support-close]')) setTimeout(syncOverlayState, 0);
    });
  }
})();

/* 2026-06-16 PDP sticky stack cache clamp: runtime guard for stale mobile cached theme shells. */
(() => {
  const styleId = 'dominator-sticky-stack-cache-clamp';
  const css = "\n\n/* 2026-06-16 PDP sticky stack cache clamp: keeps older cached storefront HTML from serving the tall PDP sticky stack. */\n.template-product .site-header.is-scrolled {\n  background: #050506 !important;\n  background-color: #050506 !important;\n  color: #fff !important;\n}\n\n.template-product .site-header.is-scrolled .site-header__inner {\n  min-height: 42px !important;\n  height: 42px !important;\n  padding-top: 0 !important;\n  padding-bottom: 0 !important;\n}\n\n.template-product .pdp-anchor-nav {\n  top: var(--sticky-header-offset, 42px) !important;\n  height: 20px !important;\n  min-height: 20px !important;\n  max-height: 20px !important;\n  align-items: center !important;\n  padding-top: 0 !important;\n  padding-bottom: 0 !important;\n  border-top: 0 !important;\n  border-bottom: 1px solid rgba(255, 255, 255, 0.14) !important;\n  background: #050506 !important;\n  box-shadow: none !important;\n  overflow-y: hidden !important;\n}\n\n.template-product .pdp-anchor-nav a {\n  height: 18px !important;\n  min-height: 18px !important;\n  max-height: 18px !important;\n  padding-top: 0 !important;\n  padding-bottom: 0 !important;\n  border-radius: 3px !important;\n  line-height: 1 !important;\n}\n\n.template-product .pdp-anchor-nav a.is-active,\n.template-product .pdp-anchor-nav a[aria-current=\"true\"] {\n  border-color: #006cff !important;\n  background: #006cff !important;\n  color: #fff !important;\n  box-shadow: none !important;\n}\n\n.template-product #help-me-choose,\n.template-product #product-compare,\n.template-product #inspect,\n.template-product #social-proof,\n.template-product #reviews,\n.template-product #questions {\n  scroll-margin-top: calc(var(--sticky-header-offset, 42px) + 24px) !important;\n}\n\n@media (max-width: 720px) {\n  .template-product .site-header.is-scrolled .site-header__inner {\n    min-height: 42px !important;\n    height: 42px !important;\n    padding-left: 18px !important;\n    padding-right: 18px !important;\n  }\n\n  .template-product .pdp-anchor-nav {\n    top: var(--sticky-header-offset, 42px) !important;\n    height: 20px !important;\n    min-height: 20px !important;\n    max-height: 20px !important;\n    grid-auto-columns: minmax(78px, 1fr) !important;\n    padding-left: 8px !important;\n    padding-right: 8px !important;\n    overflow-x: auto !important;\n    scrollbar-width: none !important;\n  }\n\n  .template-product .pdp-anchor-nav::-webkit-scrollbar {\n    display: none !important;\n  }\n\n  .template-product .pdp-anchor-nav a {\n    height: 18px !important;\n    min-height: 18px !important;\n    max-height: 18px !important;\n    padding-left: 6px !important;\n    padding-right: 6px !important;\n    font-size: 8px !important;\n  }\n}\n";
  const upsertStyle = () => {
    let style = document.getElementById(styleId);
    if (!style) {
      style = document.createElement('style');
      style.id = styleId;
      document.head.appendChild(style);
    }
    style.textContent = css;
  };
  const syncOffset = () => {
    const header = document.querySelector('[data-site-header]');
    const inner = header?.querySelector('.site-header__inner');
    if (!header || !inner) return;
    if (header.classList.contains('is-scrolled')) {
      document.documentElement.style.setProperty('--sticky-header-offset', Math.ceil(inner.getBoundingClientRect().height) + 'px');
    }
  };
  upsertStyle();
  requestAnimationFrame(syncOffset);
  window.addEventListener('scroll', () => requestAnimationFrame(syncOffset), { passive: true });
  window.addEventListener('resize', () => requestAnimationFrame(syncOffset));
})();
